import styled from "styled-components";

const NAV_WIDTH = 270;
const NAVBAR_HEIGHT = 78; /* 78px is the height of TopNavigation */

export const ActiveLink = styled.span<{ isActive: boolean }>`
  ${({ isActive }) => isActive && `a { color: #e60000 !important; }`}
`;

export const ActiveParagraph = styled.span<{ isActive: boolean }>`
  ${({ isActive }) => isActive && `p { color: #e60000 !important; }`}
`;

export const ProductNavStyles = styled.div`
  z-index: 12;
  height: 100vh;
  width: ${NAV_WIDTH}px;
  overflow: auto;
  position: fixed;
  box-shadow: 0 10px 18px 0 rgb(0 0 0 / 16%); /* Same box-shadow as <Container elevate={true} /> */
  background-color: white;
  padding: 1.5rem 1.5rem 5rem 1.5rem; /* Needs extra padding at the bottom  */
`;

export const ProductChildStyles = styled.div<{ noMargin?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
  margin-left: ${({ noMargin }) =>
    noMargin
      ? 0
      : NAV_WIDTH}px; /* We need to offset the 'children' by the Navbar's width */

  > div:not(#bottomActionBar) {
    flex-grow: 1;
  }
`;
